module.exports = __webpack_public_path__ + "static/media/publishing_image2.d2a780a1.webp";